import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=a2abfaa4&scoped=true&"
import script from "./appFooter.vue?vue&type=script&lang=js&"
export * from "./appFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2abfaa4",
  null
  
)

export default component.exports